import {
  BaseResource,
  paginatedListSerializer,
  ResourceAction,
  UuidResourceParam,
} from "@megarax/rest-resource";
import { Serializers } from "@megarax/serializers";

import { NewGroupInput, UpdateGroupInput } from "./commands";
import { GroupDto, GroupListFilters, GroupSimple } from "./queries";

export type { GroupListFilters, NewGroupInput, GroupDto, UpdateGroupInput, GroupSimple };

const list = ResourceAction({
  name: "list",
  method: "get",
  path: "",
  querySerializer: Serializers.object<GroupListFilters>({
    searchText: Serializers.string.optional(),
    limit: Serializers.integer.optional(),
    offset: Serializers.integer.optional(),
  }),
  responseSerializer: paginatedListSerializer(
    Serializers.object<GroupSimple>({
      name: Serializers.string,
      uuid: Serializers.uuid(),
    }),
  ),
});

export const groupResource = BaseResource(["iam", "groups"], {
  create: ResourceAction({
    name: "create",
    method: "post",
    path: "",
    requestBodySerializer: Serializers.object<NewGroupInput>({
      name: Serializers.string,
      uuid: Serializers.uuid(),
      roles: Serializers.array(
        Serializers.object({
          uuid: Serializers.uuid(),
        }),
      ),
    }),
  }),
  list,
  byUuid: UuidResourceParam("groupUuid", {
    retrieve: ResourceAction({
      name: "retrieve",
      method: "get",
      path: "",
      responseSerializer: Serializers.object<GroupDto>({
        name: Serializers.string,
        uuid: Serializers.uuid(),
        roles: Serializers.array(
          Serializers.object({
            name: Serializers.string,
            uuid: Serializers.uuid(),
          }),
        ),
      }),
    }),
    update: ResourceAction({
      name: "update",
      method: "put",
      path: "",
      requestBodySerializer: Serializers.object<UpdateGroupInput>({
        name: Serializers.string,
        roles: Serializers.array(
          Serializers.object({
            uuid: Serializers.uuid(),
          }),
        ),
      }),
    }),
  }),
});
